const nonLettersRegExp = /-\/:-@\[-\{\}\]-~\s\s+/g;

/*
 * Taking full name as parameter and returns initials. It doesn't return more
 * than 2 letters but can return just one or empty string.
 * ex. 'Bob Dilan' => 'BD'; 'Makus von Baden' => 'MB', 'Bob' => 'B', ' ' => ''
 */
export const parseInitials = name => {
  if (!name) {
    return "";
  }

  const normalizedName = name.replace(nonLettersRegExp, " ").trim();

  if (!normalizedName) {
    return "";
  }

  const matches = normalizedName.split(" ");

  if (matches.length === 0) {
    return normalizedName.charAt(0);
  } else if (matches.length === 1) {
    return `${matches[0].charAt(0)}`;
  } else {
    return `${matches[0].charAt(0)}${matches[matches.length - 1].charAt(0)}`;
  }
};
